import { Icon, IconName } from '@frontend/icons';
import { CommonHTMLAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { styles, Text, Truncated } from '@frontend/design-system';

type PopoverMenuTextItemProps = {
  children: string;
  iconName?: IconName;
} & CommonHTMLAttributes;

export const PopoverMenuTextItem = ({ children, iconName, ...rest }: PopoverMenuTextItemProps) => {
  if (iconName) {
    return (
      <div css={{ display: 'flex', alignItems: 'center', padding: theme.spacing(1, 2), maxWidth: '100%' }} {...rest}>
        <Icon name={iconName} css={{ marginRight: theme.spacing(1) }} />
        <Truncated as={Text} css={{ fontWeight: 'bold', ...styles.multilineTruncate(2) }}>
          {children}
        </Truncated>
      </div>
    );
  }

  return (
    <Text css={{ padding: theme.spacing(1, 2, 0.5), fontWeight: 'bold' }} {...rest}>
      {children}
    </Text>
  );
};
